<template>
  <mrc_ess_skeleton_loader :loading='$store.state.uuid ? skeletonloading : false'>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_The_parameter_name')+'*'"
                               :isNational="judegNational('param_name')"
                               :error-messages="$errors('list','param_name',requiredRule.concat(nocharacter))"
                               :readonly="disabled"
                               v-model="list.param_name">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_Parameters_of_the_key_name')+'*'"
                               :readonly="disabled"
                               :isNational="judegNational('param_key')"
                               :error-messages="$errors('list','param_key',requiredRule.concat(nocharacter).concat([
                              {
                               rule:'test',
                               msg:$t('verify_only_input_numbers_underscores_and_English_letters')
                               }
                               ]))"
                               v-model="list.param_key">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <!-- .concat(nocharacter).concat([
                              {
                               rule:'test',
                               msg:$t('verify_only_input_numbers_underscores_and_English_letters')
                               }
                               ]) -->
            <mrc_ess_multiText v-model="list.param_key_value"
                               :readonly="disabled"
                               :isNational="judegNational('param_key_value')"
                               :error-messages="$errors('list','param_key_value',requiredRule)"
                               :label="$t('label_value')+'*'">
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_prompt :label="$t('label_The_type_of_business')+'*'"
                            :disabled='disabled'
                            :rules='false'
                            :chips="false"
                            :errMsg="$errors('list','business_type',requiredRule)"
                            v-model="list.business_type"
                            obj="business_type">
            </mrc_ess_prompt>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText :label="$t('label_describe')"
                               noRequired
                               :error-messages="
                  $errors('list', 'param_description', nocharacter)
                  "
                               :isNational="judegNational('param_description')"
                               :readonly="disabled"
                               v-model="list.param_description">
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn @cancel='cancel'
                         v-if="!disabled"
                         :loading='loading'
                         @success='success'></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>
<style scoped>
</style> 
<script>  
import { required, maxLength, between, email, url } from 'vuelidate/lib/validators'
import { getSystemParameterList, detailSystemParameter, addSystemParameter, updateSystemParameter, deleteSystemParameter } from '@/service/api/systemParameter.js'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      skeletonloading: true,
      items: [],
      list: {},
      loading: false
    };
  },
  validations: {
    list: {
      param_key: {
        required, nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        }, test (value) {
          return /^[0-9a-zA-Z_]{1,}$/.test(value)
        }
      },
      param_key_value: {
        required,
        //  nocharacter (value) {
        //   return this.$myVerify.nocharacter(this.INT(value))
        // }, test (value) {
        //   return /^[0-9a-zA-Z_]{1,}$/.test(value)
        // }
      },
      param_name: {
        required, nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      business_type: {
        required
      },
      param_description: {
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
    }
  },
  created () { },
  async mounted () {
    this.national('mrbase_sys_params_setting')
    if (this.$store.state.uuid) {
      await this.getDetail()
    }
    else {

    }
  },
  methods: {
    async getDetail () {
      this.skeletonloading = true
      const res = await detailSystemParameter({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        this.list = this.$deletefield(null, res.data)
      }
      else {

      }
      this.skeletonloading = false
    },
    cancel () {
      if (this.$store.state.uuid) {
        this.getDetail()
        this.$emit('changeReadonly')
      }
      else {
        this.$myConfirm({
          content: this.$t('message_Confirm_the_cancellation_of_the_edit')
        }).then(res => {
          this.$router.push({
            name: 'systemParameter'
          })
        }).catch(err => { })
      }
    },
    async success () {
      this.$v.list.$touch()
      if (this.$v.list.$error) return
      if (this.$store.state.uuid) {
        this.loading = true
        await updateSystemParameter(this.list)
          .then(async res => {
            if (res.code == 200) {
              this.$Message({ text: this.$t('message_The_operation_was_successful') })
              await this.getDetail()
              this.$emit('changeReadonly')
            }
          })
        this.loading = false
      }
      else {
        addSystemParameter(this.list).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_added_successfully') })
            this.$router.push({ name: 'systemParameter' })
          }
        })
      }

    }
  },
  computed: {

  },
  watch: {},
};
</script>

<style scoped>
</style>
